import React from 'react';

import { formatNumber } from '@column/column-ui-kit';

import { TableColumn } from '~/components';
import { RelativeTime } from '~/elements';
import { CardTransaction } from '~/repositories/CardTransactionRepository';
import { formatString } from '~/util';

export interface CardTransactionRow {
  id: string;
  cardProgramId: string;
  cardAccountId: string;
  cardId: string;
  cardTokenId?: string;
  type: string;
  merchant: string;
  cardholderAuthorizedAmount: string;
  cardholderSettledAmount: string;
  createdAt: Date;
}

const formatAmount = (amount?: { amount: number; currencyCode: string }): string => {
  if (!amount) {
    return '-';
  }

  return formatNumber(amount.amount, amount.currencyCode);
};

export const mapCardTransactionRow = (transaction: CardTransaction): CardTransactionRow => ({
  id: transaction.id,
  cardProgramId: transaction.cardProgramId,
  cardAccountId: transaction.cardAccountId,
  cardId: transaction.cardId,
  cardTokenId: transaction.cardTokenId,
  type: transaction.type ? formatString(transaction.type) : '-',
  merchant: transaction.cardAcceptorDetails?.name || '-',
  cardholderAuthorizedAmount: formatAmount(transaction.totalAmounts?.cardholderAuthorized),
  cardholderSettledAmount: formatAmount(transaction.totalAmounts?.cardholderSettled),
  createdAt: transaction.createdAt,
});

export const cardTransactionColumns: TableColumn<CardTransactionRow>[] = [
  {
    Header: 'Merchant Name',
    accessor: 'merchant',
    width: 'minmax(180px, 1fr)',
  },
  {
    Header: 'Card ID',
    accessor: 'cardId',
    width: 'minmax(230px, 1.4fr)',
  },
  {
    Header: 'Type',
    accessor: 'type',
    width: 'minmax(140px, 0.8fr)',
  },
  {
    Header: 'Cardholder Authorized',
    accessor: 'cardholderAuthorizedAmount',
    width: 'minmax(160px, 0.9fr)',
  },
  {
    Header: 'Cardholder Settled',
    accessor: 'cardholderSettledAmount',
    width: 'minmax(150px, 0.9fr)',
  },
  {
    Header: 'Created',
    accessor: 'createdAt',
    width: 'minmax(150px, 0.8fr)',
    Cell: (current) => <RelativeTime timestamp={current.value} />,
  },
];
